import { useState } from "react";
import { useI18n } from "../i18n";
import { acceptInvite, type MyInvite } from "../data";
import { LangSwitch } from "../components/LangSwitch";

/** Shown to a signed-in person who has no company yet but has been invited to one. */
export function Join({ invites, onJoined, onSetUp, onSignOut }: {
  invites: MyInvite[]; onJoined: () => void; onSetUp: () => void; onSignOut: () => void;
}) {
  const { t, pick } = useI18n();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function join(code: string) {
    setBusy(true);
    setError(null);
    try { await acceptInvite(code); onJoined(); }
    catch (err) { setError(err instanceof Error ? err.message : t("errorGeneric")); setBusy(false); }
  }

  return (
    <main className="auth">
      <div className="auth-top row"><LangSwitch /><button type="button" className="btn secondary small" onClick={onSignOut}>{t("signOut")}</button></div>
      <div className="auth-card">
        <img src="/peoplecore-logo.svg" alt="PeopleCore" height={40} className="auth-logo" />
        <h1>{t("joinTitle")}</h1>
        <p className="muted">{t("joinBody")}</p>
        {invites.map((i) => (
          <div key={i.code} className="invite-row">
            <div>
              <div className="strong">{pick(i.company_name, i.company_name_ar)}</div>
              <div className="muted small-note">{pick(i.role_en, i.role_ar)}</div>
            </div>
            <button type="button" className="btn primary" disabled={busy} onClick={() => join(i.code)}>{t("join")}</button>
          </div>
        ))}
        {error && <p className="alert danger" role="alert">{error}</p>}
        <button type="button" className="link" onClick={onSetUp}>{t("orSetUp")}</button>
      </div>
    </main>
  );
}
